import { localEnvironment } from "../../../../libs/menu-shared/src/environments/default-menu.config";

const environment = {
  production: true,
  menu: localEnvironment
};

export default environment;